import React from 'react';
import InformationBlock from '../../../../../@casino/ui/informationBlock';
import clsx from 'clsx';
import {useSelector} from 'react-redux';
import {useStyles} from './helpers';

const TwoRow = () => {
    const classes = useStyles();

    const count_users = useSelector(state => state.information.users);
    const count_new_users = useSelector(state => state.information.new_users);
    
    return (
        <div style={{height: 230, width: '50%'}}>
            <InformationBlock
                label="ИГРОКИ"
                width="100%"
                lineColor="#fa00ff">
                <div className={classes.rootBlock}>
                    <div className={clsx(classes.wrapBlock, classes.mr12, classes.users)}>
                        <span className={classes.labelBlock}>Всего</span>
                        <span className={clsx(classes.fs20, classes.countBlock)}>{new Intl.NumberFormat('ru-RU').format(count_users)}</span>
                    </div>
                    <div className={classes.wrapLabelBlock}>
                        <span className={classes.labelBlock}>Новых</span>
                        <span className={clsx(classes.fs20, classes.countBlock)}>{new Intl.NumberFormat('ru-RU').format(count_new_users)}</span>
                    </div>
                </div>
            </InformationBlock>
        </div>
    )
}

export default TwoRow;